export const departments = ['DIR', 'ADM', 'INF', 'FOR', 'IPR', 'TEC', 'MAT', 'ELE', 'IDE', 'IT'];
